import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ENVIRONMENT_CONFIG, EnvironmentConfiguration } from 'src/environments/model/environment.model';

@Injectable({
  providedIn: 'root'
})
export class DigiApiService {

  constructor(
    private readonly _http: HttpClient,
    @Inject(ENVIRONMENT_CONFIG) public environment: EnvironmentConfiguration
  ) { }

  public AuthToken = "";

  public Get<T>(url: string): Observable<T> {

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.AuthToken}`
    });

    return this._http
      .get<T>(this.environment.baseURL + url, {
        headers
      });
  }
}
